import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import CloseIcon from '@mui/icons-material/Close';

const COLORS = {
  success: {
    accent: '#12B981',
    iconBg: '#ECFEF6',
    iconBorder: '#12B981',
    iconColor: '#12B981',
  },
  error: {
    accent: '#EF446E',
    iconBg: '#EF446E10',
    iconBorder: '#EF446E',
    iconColor: '#EF446E',
  },
  info: {
    accent: '#027BC6',
    iconBg: '#027BC614',
    iconBorder: '#027BC6',
    iconColor: '#027BC6',
  },
  warning: {
    accent: '#FEA26F',
    iconBg: '#FEA27005',
    iconBorder: '#FEA26F',
    iconColor: '#FEA26F',
  },
};

const ICONS = {
  success: CheckIcon,
  error: ErrorOutlineIcon,
  info: InfoOutlinedIcon,
  warning: WarningAmberRoundedIcon,
};

const TITLES = {
  success: 'Succès',
  error: 'Erreur',
  info: 'Information',
  warning: 'Attention',
};

const ToastContent = ({ severity = 'success', message, closeToast }) => {
  const c = COLORS[severity] || COLORS.success;
  const Icon = ICONS[severity] || ICONS.success;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
        backgroundColor: '#FFFFFF',
        borderRadius: '8px',
        boxShadow: '0px 12px 26px #0000001C',
        border: '1px solid #F7F7F7',
        pl: '24px',
        pr: '40px',
        py: '18px',
        minHeight: '90px',
        width: '100%',
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          left: 0,
          top: 0,
          bottom: 0,
          width: '4px',
          backgroundColor: c.accent,
          borderRadius: '8px 0 0 8px',
        }}
      />
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          border: `1px solid ${c.iconBorder}`,
          backgroundColor: c.iconBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Icon sx={{ color: c.iconColor, fontSize: 20 }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          sx={{
            fontSize: '15px',
            fontWeight: 700,
            color: '#1A2035',
            lineHeight: 1.3,
          }}
        >
          {TITLES[severity]}
        </Typography>
        <Typography
          sx={{
            fontSize: '13px',
            fontWeight: 500,
            color: '#385576',
            mt: '4px',
            lineHeight: 1.4,
          }}
        >
          {message}
        </Typography>
      </Box>
      {closeToast && (
        <IconButton
          onClick={closeToast}
          size="small"
          sx={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            color: '#8398AE',
            p: '2px',
            '&:hover': { color: '#385576' },
          }}
        >
          <CloseIcon sx={{ fontSize: 15 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default ToastContent;
